import { setContext } from "@apollo/client/link/context";
import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";

export const AUTH_TOKEN_KEY = "mq_auth_token";
export const AUTH_REFRESH_TOKEN_KEY = "mq_refresh_token";
export const AUTH_STATE_CHANGE_EVENT = "mq-auth-changed";
const LEGACY_AUTH_TOKEN_KEY = "auth-token";

const dispatchAuthStateChange = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(AUTH_STATE_CHANGE_EVENT));
};

export const getAuthToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return (
    window.localStorage.getItem(AUTH_TOKEN_KEY) ||
    window.localStorage.getItem(LEGACY_AUTH_TOKEN_KEY)
  );
};

export const setAuthTokens = ({ authToken, refreshToken } = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  if (authToken) {
    window.localStorage.setItem(AUTH_TOKEN_KEY, authToken);
  }

  if (refreshToken) {
    window.localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, refreshToken);
  }

  dispatchAuthStateChange();
};

export const clearAuthTokens = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  window.localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY);
  dispatchAuthStateChange();
};

const link = createHttpLink({
  uri: `${process.env.GATSBY_WP_GRAPHQL_URL}`,
  credentials: "include",
  fetchOptions: {
    mode: 'cors',
    credentials: "include",
  }
});

const authLink = setContext((_, { headers }) => {
  const authToken = getAuthToken();
  const authorizationHeader = authToken ? `Bearer ${authToken}` : undefined;

  return {
    headers: {
      ...headers,
      ...(authorizationHeader ? { Authorization: authorizationHeader, authorization: authorizationHeader } : {}),
    },
  };
});

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authLink, link]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy:'network-only',
      errorPolicy: 'all'
    },
    query: {
      fetchPolicy:'network-only',
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  onError: ({ graphQLErrors, networkError }) => {
    // if (graphQLErrors)
//       graphQLErrors.forEach(({ message, locations, path }) =>
//         console.log(
//           `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
//         )
//       );
    // if (networkError) console.log(`[Network error]: ${networkError}`);
  }
});
